/**
 * 2020/4/1 - 15:10
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    token: null,
    userInfo: null
  },
  getters: {
    userInfo: state => {
      return state.userInfo ? state.userInfo : Vue.ls.get('userInfo')
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      Vue.ls.set('userInfo', userInfo)
    }
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        Vue.$http.app.login(userInfo).then(response => {
          const { data: { token, userInfo } } = response
          // console.log('token ===> ', token)
          Vue.ls.set('Token', token, 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', userInfo)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
